function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.565 16.573a.492.492 0 01-.165-.955l6.942-2.476a.492.492 0 11.331.927l-6.942 2.476a.5.5 0 01-.166.028zM9.026 14.942a.492.492 0 01-.469-.345L4.366 1.265a.468.468 0 00-.383-.281H.492a.492.492 0 010-.984h3.491a1.434 1.434 0 011.321.97l4.191 13.332a.492.492 0 01-.321.617.5.5 0 01-.148.023z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10 19.999a3.115 3.115 0 113.115-3.115A3.118 3.118 0 0110 19.999zm0-5.246a2.131 2.131 0 102.131 2.131A2.134 2.134 0 0010 14.754z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("g", null,
/*#__PURE__*/
React.createElement("path", {
  d: "M12.144 13.443a.492.492 0 01-.467-.338l-1.95-5.918a.491.491 0 01.319-.623l6.187-1.951a.492.492 0 01.613.309l2.026 5.9a.492.492 0 01-.318.629l-6.263 1.967a.489.489 0 01-.147.025zm-1.327-6.091l1.643 4.984 5.318-1.671-1.706-4.971z"
}));

var SvgFulfillment = function SvgFulfillment(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 20,
      height: 20,
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2, _ref3, _ref4)
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgFulfillment, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/Fulfillment.d5589670.svg";
export { ForwardRef as ReactComponent };